module.exports = __webpack_public_path__ + "static/img/doudou.4d52b80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/doudou.jpg
// module id = JgKV
// module chunks = 1